import { useMemo, useState } from "react";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription, DialogFooter } from "@/components/ui/dialog";
import { Textarea } from "@/components/ui/textarea";
import { Button } from "@/components/ui/button";
import { parsePastedList } from "@/lib/parsePaste";
import { PASTE } from "@/constants/testIds";

const EXAMPLE = "Budi Santoso\t21/07/2027\n2. Siti Aminah - 20-07-2027\nAndi 15 Desember 2028";

export const PasteDialog = ({ open, onOpenChange, onApply }) => {
  const [text, setText] = useState("");
  const result = useMemo(() => parsePastedList(text), [text]);

  const apply = () => {
    onApply(result.rows);
    setText("");
    onOpenChange(false);
  };

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="sm:max-w-xl" data-testid={PASTE.dialog}>
        <DialogHeader>
          <DialogTitle className="font-heading tracking-tight">Tempel Daftar Peserta</DialogTitle>
          <DialogDescription>Salin langsung dari Excel (No, Nama, ..., Tgl Lahir, Tgl Expired) atau daftar WhatsApp. Jika ada beberapa tanggal dalam satu baris, tanggal paling akhir dianggap tanggal expired paspor.</DialogDescription>
        </DialogHeader>
        <Textarea value={text} onChange={(e) => setText(e.target.value)} rows={9} placeholder={EXAMPLE} className="font-mono text-sm" data-testid={PASTE.textarea} />
        {text.trim() && (
          <div className="space-y-2 text-sm" data-testid={PASTE.preview}>
            <p className="text-emerald-700 font-medium" data-testid={PASTE.okCount}>{result.rows.length} peserta dikenali</p>
            {result.rows.length > 0 && (
              <ul className="max-h-40 overflow-y-auto rounded-md border border-slate-200 divide-y divide-slate-100 text-xs" data-testid={PASTE.rowsPreview}>
                {result.rows.map((r, i) => (
                  <li key={i} className="flex justify-between gap-3 px-3 py-1.5">
                    <span className="truncate text-slate-700">{i + 1}. {r.name || "(tanpa nama)"}</span>
                    <span className="shrink-0 tabular-nums text-slate-500">Exp. {r.exp}</span>
                  </li>
                ))}
              </ul>
            )}
            {result.failed.length > 0 && (
              <div className="rounded-md border border-amber-200 bg-amber-50 p-3 text-amber-800" data-testid={PASTE.failed}>
                <p className="font-medium">{result.failed.length} baris dilewati (tanggal tidak terbaca):</p>
                <ul className="mt-1 max-h-24 overflow-y-auto text-xs">
                  {result.failed.map((l, i) => <li key={i} className="truncate">• {l}</li>)}
                </ul>
              </div>
            )}
          </div>
        )}
        <DialogFooter>
          <Button variant="outline" className="rounded-full" onClick={() => onOpenChange(false)}>Batal</Button>
          <Button disabled={!result.rows.length} onClick={apply} className="rounded-full bg-brand hover:bg-brand-dark text-white" data-testid={PASTE.apply}>
            Masukkan {result.rows.length || ""} peserta
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};
